import { daysToMilliseconds } from '@lib/utils/time';

export const sevenDaysInMS = daysToMilliseconds(7);
export const oneDayInMS = daysToMilliseconds(1);

interface SelectionOption<Name, Value> {
  name: Name;
  value: Value;
}

export function mapToSelectionOption<Id, Name>(object: {
  id: Id;
  name: Name;
}): SelectionOption<Name, Id> {
  return {
    name: object.name,
    value: object.id,
  };
}

export const alphabetizeOptions = (
  a: { name: string; value: string },
  b: { name: string; value: string },
) => a.name.localeCompare(b.name);
